import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../site/Reveal";

const CHAPTERS = [
  {
    no: "01",
    title: "Built On Trust",
    body: "Gas Safe registered, fully insured and RPCP / OFTEC accredited. Every job is carried out to certified standards you can rely on.",
  },
  {
    no: "02",
    title: "Skilled Craft",
    body: "Our tradespeople bring years of hands-on experience across twelve disciplines — from fine joinery to complete renovations.",
  },
  {
    no: "03",
    title: "Honest Value",
    body: "Clear, upfront quotes with no hidden costs. Quality workmanship at prices that keep your project moving.",
  },
];

const Chapter = ({ chapter, index }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["30%", "-30%"]);

  return (
    <div ref={ref} className="relative grid lg:grid-cols-12 gap-6 items-center py-14 border-b border-white/10">
      <div className="lg:col-span-3 relative overflow-hidden">
        <motion.span
          style={{ y }}
          className="font-display font-700 text-[26vw] lg:text-[12rem] leading-none text-stroke select-none block"
        >
          {chapter.no}
        </motion.span>
      </div>
      <Reveal delay={0.05} className="lg:col-span-4 lg:col-start-5">
        <h3 className="font-display uppercase tracking-tight text-4xl sm:text-5xl text-cream leading-none">
          {chapter.title}
        </h3>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-3 lg:col-start-10">
        <p className="text-cream/70 leading-relaxed">{chapter.body}</p>
      </Reveal>
    </div>
  );
};

export const Manifesto = () => (
  <section className="relative bg-forest-deep py-24 md:py-32 noise-overlay" data-testid="manifesto-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal className="max-w-3xl">
        <span className="font-display uppercase tracking-[0.25em] text-xs text-brand-orange">Why Bezalel</span>
        <h2 className="mt-4 font-display uppercase tracking-tight text-5xl sm:text-6xl lg:text-7xl text-cream leading-[0.95]">
          A trade you can <span className="text-brand-orange">stand behind</span>
        </h2>
      </Reveal>
      <div className="mt-14">
        {CHAPTERS.map((c, i) => (
          <Chapter key={c.no} chapter={c} index={i} />
        ))}
      </div>
    </div>
  </section>
);
